import { fbt } from 'fbtee'

export function searchStrings() {
  return {
    placeholder: fbt(
      'Search events, artists…',
      "Placeholder of the Search tab's search box, and of the Discover page button that opens it",
    ),
    hint: fbt(
      'Search events, artists, people and your groups',
      'Hint shown under the browse search box before anything is typed',
    ),
    festivalsHeading: fbt('Festivals', 'Global search result group heading for festivals'),
    partiesHeading: fbt('Parties', 'Global search result group heading for parties'),
    artistsHeading: fbt('Artists', 'Global search result group heading for artists'),
    peopleHeading: fbt('People', 'Global search result group heading for people'),
    peopleGuestCta: fbt(
      'Log in to search for people',
      'Row in the global search People section shown to signed-out visitors',
    ),
    groupsHeading: fbt('Your groups', "Global search result group heading for the viewer's groups"),
    noResults: (query: string) =>
      fbt('No results for "' + fbt.param('query', query) + '"', 'Global search empty state (fbt:param query)'),
    offline: fbt(
      "You're offline. Search will be available once you reconnect.",
      'Global search state when offline with no cached index',
    ),
    error: fbt("Couldn't load search.", 'Global search error state'),
    recentHeading: fbt('Recent', 'Heading above the search results the viewer tapped before'),
    clearRecent: fbt('Clear', 'Button that clears the recent searches list'),
    past: fbt('Past', 'Badge on a global search result for an event that already happened'),
    far: fbt(
      'Far',
      "Badge on a global search result for an event outside the viewer's home region and its nearby area",
    ),
    lineup: fbt('Lineup', 'Suffix on an artist appearance row with no set time'),
  }
}
